if (!customElements.get('pop-menu')) {
  customElements.define(
    'pop-menu',
    class PopMenu extends HTMLElement {
      constructor() {
        super();
        this.isInitialized = false;
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      }

      connectedCallback() {
        if (this.isInitialized) return;
        this.elements = {
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        this.isInitialized = true;
      }

      hide() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hide();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {}

      openSelector(event) {
          this.elements.button.focus();
          this.elements.panel.toggleAttribute('hidden');
          this.elements.button.setAttribute(
            'aria-expanded',
            (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
          );
      }

      closeSelector(event) {
        const isChild = this.elements.panel.contains(event.target) || this.elements.button.contains(event.target);

        if (!event.relatedTarget || !isChild) {
          console.log('hide 1');
          this.hide();
        }
      }
    }
  );
}
